import { createI18n } from 'vue-i18n'
import DataStore from '@/globals/data-store.js'
import en from './en.json'
import fr from './fr.json'
import de from './de.json'
import es from './es.json'
import ru from './ru.json'
import nl from './nl.json'
import it from './it.json'
import ar from './ar.json'
import ja from './ja.json'

import enElemenUILocale from 'element-plus/dist/locale/en.js'
import frElemenUILocale from 'element-plus/dist/locale/fr.js'
import deElemenUILocale from 'element-plus/dist/locale/de.js'
import esElemenUILocale from 'element-plus/dist/locale/es.js'
import ruElemenUILocale from 'element-plus/dist/locale/ru.js'
import nlElemenUILocale from 'element-plus/dist/locale/nl.js'
import itElemenUILocale from 'element-plus/dist/locale/it.js'
import arElemenUILocale from 'element-plus/dist/locale/ar.js'
import jaElemenUILocale from 'element-plus/dist/locale/ja.js'

const messages = {
  ar: Object.assign(ar, arElemenUILocale),
  en: Object.assign(en, enElemenUILocale),
  fr: Object.assign(fr, frElemenUILocale),
  de: Object.assign(de, deElemenUILocale),
  es: Object.assign(es, esElemenUILocale),
  it: Object.assign(it, itElemenUILocale),
  nl: Object.assign(nl, nlElemenUILocale),
  ru: Object.assign(ru, ruElemenUILocale),
  ja: Object.assign(ja, jaElemenUILocale)
}

const language = DataStore.getLanguage()
const i18n = createI18n({
  locale: language.code,
  messages
})

/**
 * @returns {string} The current locale
 */
export const getCurrentLocale = () => {
  return i18n.global.locale
    ? i18n.global.locale
    : Intl.NumberFormat().resolvedOptions().locale;
}

export default i18n
export const t = i18n.global.t
export const $t = i18n.global.t
